import * as React from "react"
import { parseDiff } from "react-diff-view"
import { uniqueId } from "lodash"
import { formatLines, diffLines } from "unidiff"
import DiffView from "./DiffView"
import { IChange, IParsedDiff } from "./index"

const fakeIndex = (): string => uniqueId("index_")

type Props = IChange

export default class FileDiff extends React.Component<Props> {
    render(): JSX.Element {
        return this.renderDiff(this.props)
    }

    renderDiff(change: IChange): JSX.Element {
        if (change.kind === "Added") {
            change = {
                ...change,
                oldSource: "<added file>",
                newSource: change.newSource || "<empty file>",
            }
        } else if (change.kind === "Deleted") {
            change = {
                ...change,
                oldSource: change.oldSource || "<empty file>",
                newSource: "<deleted file>",
            }
        } else if (change.kind === "Renamed") {
            change = {
                ...change,
                oldSource: "<old file>",
                newSource: "<new file>",
            }
        } else if (change.kind === "Copied") {
            change = {
                ...change,
                oldSource: "<original file>",
                newSource: "<new file>",
            }
        } else if (change.kind === "Modified") {
            change = {
                ...change,
                oldSource: change.oldSource || "<empty file>",
                newSource: change.newSource || "<empty file>",
            }
        } else {
            throw new Error("Unsupported change kind: " + change.kind)
        }

        const diff = formatLines(
            diffLines(change.oldSource, change.newSource),
            { context: 3 },
        )

        return this.renderDiffView(diff, change)
    }

    renderDiffView(diff: string, change: IChange): JSX.Element {
        const parsedDiff = this.parse(diff)

        return !!parsedDiff && !!parsedDiff.type && !!parsedDiff.hunks ? (
            <DiffView
                change={change}
                key={uniqueId("diff_")}
                type={parsedDiff.type}
                hunks={parsedDiff.hunks}
                oldSource={change.oldSource}
                showGutter={true}
            />
        ) : (
            <></>
        )
    }

    parse(diff: string): IParsedDiff | null {
        if (!diff) {
            return null
        }

        const segments = [
            "diff --git a/a b/b",
            `index ${fakeIndex()}..${fakeIndex()} 100644`,
            diff,
        ]

        const files = parseDiff(segments.join("\n"), { nearbySequences: "zip" })

        return files[0]
    }
}
